export default {
  data() {
    return {
      API_URL: 'https://api-staging.zero1.id',
      notices: [

      ],
      isDarkMode: false,
    }
  },
  methods: {
    updateMenu() {
      window.$('.os-dropdown-trigger').on('mouseenter', function () {
        window.$(this).addClass('over');
      });
      window.$('.os-dropdown-trigger').on('mouseleave', function () {
        window.$(this).removeClass('over');
      });
      window.$('.mobile-menu-trigger').on('click', function () {
        if (!this.mobileClick) {
          this.mobileClick = true
          window.$('.menu-mobile .menu-and-user').slideToggle('swing');
          setTimeout(() => {
            this.mobileClick = false
          }, 500)
          return false;
        }
      })
    },
  },
  created() {
    this.updateMenu()
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    $('#triggerDark').on('click', function () {
      console.log('test')
    });
  },
  watch: {
    $route: 'updateMenu'
  },
}
